import { useMemo } from 'react';
import { useDynamicParameters } from 'context/DynamicParameters/DynamicParametersContext';
import { ELiveRatesExternalSystem } from 'services/BackendApi/types/LiveRatesInternal';

export type SupplierConfig = {
  externalSystem: ELiveRatesExternalSystem;
  name: string;
  requiredFields: string[];
  enabled: boolean;
};

const config: Omit<SupplierConfig, 'enabled'>[] = [
  {
    externalSystem: ELiveRatesExternalSystem.DERBYSOFT,
    name: 'DerbySoft',
    requiredFields: ['externalSystem', 'externalHotelId', 'externalSupplierId']
  },
  {
    externalSystem: ELiveRatesExternalSystem.ILLUSIONS,
    name: 'Illusions',
    requiredFields: ['externalSystem', 'externalHotelId']
  },
  {
    externalSystem: ELiveRatesExternalSystem.JUMEIRAH,
    name: 'Jumeirah',
    requiredFields: ['externalSystem', 'externalHotelId']
  },
  {
    externalSystem: ELiveRatesExternalSystem.HILTON,
    name: 'Hilton',
    requiredFields: ['externalSystem', 'externalHotelId']
  },
  {
    externalSystem: ELiveRatesExternalSystem.HYPERGUEST,
    name: 'Hyperguest',
    requiredFields: ['externalSystem', 'externalHotelId']
  },
  {
    externalSystem: ELiveRatesExternalSystem.ZINANTIS,
    name: 'Zinantis',
    requiredFields: ['externalSystem', 'externalHotelId']
  },
  {
    externalSystem: ELiveRatesExternalSystem.MOCK,
    name: 'Mock',
    requiredFields: ['externalSystem', 'externalHotelId']
  }
];

export const useSupplierConfig = () => {
  const { dynamicParameters } = useDynamicParameters();

  const enriched = useMemo(() =>
    config.map(x => ({
      ...x,
      enabled: dynamicParameters.LIVE_RATE_SUPPLIERS_LIST?.includes(x.externalSystem) || false
    })),
    [dynamicParameters.LIVE_RATE_SUPPLIERS_LIST]
  );

  return { supplierConfig: enriched };
};
